import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import Overview from '../pages/Overview.jsx';
import UsersList from '../pages/UsersList.jsx';
import Roles from '../pages/Roles.jsx';
import Invitations from '../pages/Invitations.jsx';
import Sessions from '../pages/Sessions.jsx';

/**
 * Route definitions for the User Management app.
 *
 * Paths are RELATIVE to the parent route that mounts this component:
 *   - Shell:      <Route path="users/*"> → remaining path is matched here
 *   - Standalone: <Route path="users/*"> wrapper in main.jsx (same convention)
 */
const UserManagementRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <ProtectedRoute>
          <Overview />
        </ProtectedRoute>
      }
    />
    <Route
      path="list"
      element={
        <ProtectedRoute>
          <UsersList />
        </ProtectedRoute>
      }
    />
    <Route
      path="roles"
      element={
        <ProtectedRoute>
          <Roles />
        </ProtectedRoute>
      }
    />
    <Route
      path="invitations"
      element={
        <ProtectedRoute>
          <Invitations />
        </ProtectedRoute>
      }
    />
    <Route
      path="sessions"
      element={
        <ProtectedRoute>
          <Sessions />
        </ProtectedRoute>
      }
    />
    <Route path="*" element={<Navigate to="/users" replace />} />
  </Routes>
);

export default UserManagementRoutes;
